var _defs, _circle, _circle2, _circle3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDummyProfileImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 600,
    height: 600,
    fill: "black",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Abstract user icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "circular-border"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 300,
    r: 280
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "avoid-antialiasing-bugs"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: 498
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 300,
    r: 280,
    fill: "white",
    clipPath: "url(#avoid-antialiasing-bugs)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 230,
    r: 115
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 550,
    r: 205,
    clipPath: "url(#circular-border)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDummyProfileImage);
export default __webpack_public_path__ + "static/media/DummyProfileImage.932c236aa58076473b9cafd60590c10e.svg";
export { ForwardRef as ReactComponent };